import { gql } from '@zenbusiness/application-commons-graphql';

export const UI_INSTRUCTION_FRAGMENT = gql`
  fragment UiInstructionFragment on UiInstruction {
    componentType
    props # arbitrary JSON blob
  }
`;
